<section class="layout-pt-lg layout-pb-lg">
  <div class="container">
    <div class="row justify-center">
      <div class="col-lg-10">
        <h1 class="text-40 fw-700 text-dark-1 mb-40 text-center">İptal Güvence Paketi</h1>
        
        <div class="bg-blue-1-05 rounded-8 px-30 py-30 mb-40">
          <p class="text-18 fw-500 text-dark-1 lh-18">
            Tatil Planınızda Değişiklik Mi Oldu? Sorun Değil, Çünkü Pusula'nın Fırsat Kampanyası İptal Güvence Paketi ile Değişiklik ve İptal Haklarınız Güvende.
          </p>
          <p class="text-16 text-dark-1 lh-18 mt-20">
            Fırsat Kampanyası İptal Güvence Paketi, tatilinizi güvence altına alır ve son anda çıkan aksiliklerden dolayı tatili planınızı değiştirmenize veya iptal etmenize olanak tanır. Fırsat Kampanyası İptal Güvence Paketi ile ulaşım bedeli hariç <strong>%100 kesintisiz iptal hakkına</strong> sahip olur ve tatilinizin iadesini alabilirsiniz.
          </p>
        </div>

        <div class="text-16 text-dark-1 lh-18">
          <h4 class="text-20 fw-600 text-dark-1 mt-40 mb-20">İptal Güvence Paketi ("İGP") Bilgilendirme</h4>
          
          <div class="bg-light-2 rounded-8 px-30 py-30 mb-30">
            <ol style="padding-left: 20px;">
              <li class="mb-15">
                <strong>Geçerlilik:</strong> İGP; yurtiçi otel konaklamaları için yapılan, minimum 1, maksimum 14 gecelik ve 23/09/2025 - 31/10/2026 tarihleri arasında konaklayacak rezervasyonlar için geçerli olacaktır. Rezervasyonlarında giriş tarihinden en az 5 gün önce yapılmış olan şartı aranacaktır.
              </li>
              <li class="mb-15">
                <strong>İptal Hakkı:</strong> İGP satın alan tüketiciler tesise giriş tarihine <strong>72 saat</strong> kalana kadar işbu İGP koşullarına uygun olarak ve kesinti yapılmadan rezervasyonlarını iptal edebilirler.
              </li>
              <li class="mb-15">
                <strong>Değişiklik:</strong> İGP aynı ürün üzerinde talep edilen tarih ya da isim değişikliklerini kapsamamaktadır. Değişiklik taleplerinde var olan İGP kapsamında iptal edilir, talep edilen yeni tarih, ürün ya da isimler için günün koşullarından yeni rezervasyon açılarak işlem yapılır.
              </li>
              <li class="mb-15">
                <strong>Satın Alma Süresi:</strong> İGP rezervasyon tarihinden itibaren 5 gün içinde ücret karşılığında sunulmaktadır. 6. gün ve sonrası için İGP alınamaz.
              </li>
              <li class="mb-15">
                <strong>İGP İadesi:</strong> İptal talebine karşılık yapılacak olan iadelerde tahsil edilen İGP tutarı iade edilemez ya da sunulan İGP iptal edilemez.
              </li>
              <li class="mb-15">
                <strong>Havayolu Rezervasyonları:</strong> Otel konaklaması ile birlikte yapılan (promosyon ve ekonomi sınıfı dahil) tüm havayolu bilet rezervasyonları İGP kapsamı dışında olup ilgili havayolu firmasının iptal koşulları ve uygulamaları geçerlidir. İGP ücretlendirmesinde uçak ve/veya otobüs ulaşım tutarı hariç konaklama ve/veya diğer hizmetler tutarı baz alınarak İGP ücreti tahsil edilir.
              </li>
              <li class="mb-15">
                <strong>Kapsam:</strong> İGP uygulaması yalnızca, 2025-2026 sezonu için belirlenen kampanyalı ve belirli yurtiçi tesislerde yapılacak otel konaklamaları için geçerlidir. İGP kapsamı dışındaki otel konaklama rezervasyonları için ilgili sözleşmedeki iptal koşulları geçerli olacaktır.
              </li>
              <li class="mb-15">
                <strong>Yurtdışı:</strong> İGP uygulaması yurtdışı otel konaklaması/seyahat rezervasyonlarını kapsamamaktadır. Yurtdışı otel konaklamasında/seyahat uygulamalarında Yurtdışı Seyahat Güvence Paketi satın alındığı takdirde bu ürünün kendisine ait olan teminat kapsamları geçerli olacaktır.
              </li>
              <li class="mb-15">
                <strong>Ücretlendirme:</strong> 2025-2026 sezonu İGP bedelleri yurtiçi otel konaklama rezervasyon tutarının <strong>yüzde 1'ini</strong> kapsayacak şekildedir.
              </li>
              <li class="mb-15">
                <strong>Salgın Hastalık:</strong> Salgın hastalık İGP kapsamına dahildir.
              </li>
              <li class="mb-15">
                <strong>Tesis İptal Politikası:</strong> Her tesisin kendine ait iptal politikası farklılık göstermektedir. "İGP" satın alınan rezervasyonlarda 72 saate kadar iptal hakkı tanınmaktadır. İGP seçili ürünlerde geçerlidir.
              </li>
            </ol>
          </div>

          <h4 class="text-20 fw-600 text-dark-1 mt-40 mb-20">İGP Kapsamı Dışında Kalan Durumlar</h4>
          
          <div class="bg-red-3 rounded-8 px-30 py-30 mb-30" style="background-color: #fff5f5;">
            <p class="mb-15 fw-500">Aşağıdaki hal ve koşullar İptal Güvence Paketi kapsamı dışında tutulacaktır:</p>
            <ul style="padding-left: 20px;">
              <li class="mb-10">
                <i class="icon-close text-red-1 mr-10"></i>
                Tesise giriş tarihine 72 saat ve daha az kalan sürelerde yapılan iptaller
              </li>
              <li class="mb-10">
                <i class="icon-close text-red-1 mr-10"></i>
                Müşteri tarafından rezervasyon ücreti tesise giriş tarihinden 72 saat öncesine kadar ödenmemiş olan işlemler
              </li>
              <li class="mb-10">
                <i class="icon-close text-red-1 mr-10"></i>
                Ulaşım ve transfer ücretleri
              </li>
              <li class="mb-10">
                <i class="icon-close text-red-1 mr-10"></i>
                Rezervasyon değişiklikleri ve değişiklikten kaynaklanan farklar
              </li>
              <li class="mb-10">
                <i class="icon-close text-red-1 mr-10"></i>
                14 geceden fazla yapılan rezervasyonlar
              </li>
              <li class="mb-10">
                <i class="icon-close text-red-1 mr-10"></i>
                Tesise giriş tarihinden en az 5 gün önce yapılmamış olan rezervasyonlar
              </li>
              <li class="mb-10">
                <i class="icon-close text-red-1 mr-10"></i>
                Sel, deprem, volkanik patlamalar, heyelan, fırtına ve meteor düşmesi gibi doğal afetler sonucu ortaya çıkan zararlar
              </li>
              <li class="mb-10">
                <i class="icon-close text-red-1 mr-10"></i>
                Harp veya harp niteliğindeki harekât, ihtilal, isyan, ayaklanma ve bunlardan doğan iç kargaşalıklar
              </li>
              <li class="mb-10">
                <i class="icon-close text-red-1 mr-10"></i>
                3713 sayılı Terörle Mücadele Kanunu'nda belirtilen terör eylemleri ve sabotaj ile bunları önlemek ve etkilerini azaltmak amacıyla yetkili organlar tarafından yapılan müdahaleler
              </li>
              <li class="mb-10">
                <i class="icon-close text-red-1 mr-10"></i>
                Nükleer rizikolar veya nükleer, biyolojik ve kimyasal silah kullanımı ya da nükleer, biyolojik ve kimyasal maddelerin açığa çıkmasına neden olacak her türlü saldırı ve sabotaj
              </li>
              <li class="mb-10">
                <i class="icon-close text-red-1 mr-10"></i>
                Politik riskler ve grevlerden meydana gelecek zarar ve hasarlar
              </li>
            </ul>
          </div>

          <div class="bg-green-1 rounded-8 px-30 py-30 mt-40" style="background-color: #f0fff4;">
            <h5 class="text-18 fw-600 text-dark-1 mb-20">
              <i class="icon-check text-green-2 mr-10"></i>
              Önemli Bilgiler
            </h5>
            <ul style="padding-left: 20px;">
              <li class="mb-10">İGP ile ulaşım bedeli hariç %100 kesintisiz iptal hakkınız bulunmaktadır.</li>
              <li class="mb-10">İptal işleminizi tesise giriş tarihine 72 saat kala yapmanız gerekmektedir.</li>
              <li class="mb-10">İGP ücreti rezervasyon tutarının %1'i kadardır.</li>
              <li class="mb-10">İGP rezervasyon tarihinden itibaren 5 gün içinde satın alınabilir.</li>
            </ul>
          </div>

          <div class="text-center mt-50">
            <p class="text-14 text-light-1">
              Detaylı bilgi ve sorularınız için müşteri hizmetlerimizi arayabilirsiniz.
            </p>
            <a href="tel:+902422120224" class="button -md -blue-1 bg-blue-1 text-white mt-20">
              <i class="icon-phone mr-10"></i>
              0242 212 02 24
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-newsletter></app-newsletter>
